import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import useApiGet from '../../hooks/useApiGet';
import Form, { FormInput } from '../common/Form';
import { getCountryName } from '../../utils/countries';
//
// Компонент выводит список стран участников мероприятия для формирования ссылки пресета
//
const PresetCountries = ({ event, cntrs, setCntrs }) => {
    const { t, i18n } = useTranslation();
    const lang = i18n.language;
    const [ data ] = useApiGet({ method: `/countries/${event._id}` });
    const [ list, setList ] = useState([]);

    // Надо исключить из списка участников без указания страны
    useEffect(() => {
        if(!data) return;
        const list = data.countries.filter(c => c.alpha3).map(c => c.alpha3);
        list.sort((a, b) => {
            if(a === 'RUS') return -1;
            if(b === 'RUS') return  1;
            let aName = getCountryName(a, lang);
            let bName = getCountryName(b, lang);
            return aName.localeCompare(bName);
        });
        setList(list);
    }, [ data, lang ]);

    const onChange = (cntr) => {
        const index = cntrs.indexOf(cntr);
        let newCntrs = [...cntrs];
        if(index < 0) {
            newCntrs.push(cntr);
        } else {
            newCntrs.splice(index, 1);
        }
        setCntrs(newCntrs);
    };

    if(!list.length) return null;

    return (            
    <Form>
        <fieldset>
        <legend>{t('preset.cntrs')}</legend>
        {list.map((item, index) => (
            <FormInput
                id={`cntr-${index}`}
                key={index}
                type='checkbox'
                value={cntrs.includes(item) ? item : ''}
                label={getCountryName(item, lang)}
                onChange={() => onChange(item)}
            />
        ))}
        </fieldset>
    </Form> 
    );
};

PresetCountries.propTypes = {
    event: PropTypes.object.isRequired,
    cntrs: PropTypes.arrayOf(PropTypes.string).isRequired,
    setCntrs: PropTypes.func.isRequired,
};

export default PresetCountries;
